import React, { useCallback, useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  DialogActions,
  Autocomplete,
  InputLabel,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import PopupState from "material-ui-popup-state";
import Div from "@jumbo/shared/Div";

import * as Yup from "yup";
import moment from "moment";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";

const AdvanceOutstandingReport = () => {
  const swal = useSwalWrapper();
  const [HelperData, setHelperData] = useState([]);

  const [currency, setCurrency] = useState([]);
  const [formval, setFormval] = useState({
    P_PARTY_CODE: "",
    P_todt: "",
    P_frdt: "",
    type: "",
    P_curr: "",
  });

  const validationSchema = Yup.object().shape({
    P_todt: Yup.date().required("To Date is required"),
    P_frdt: Yup.date().required("From Date is required"),
    P_curr: Yup.string().required("Currency is required"),
  });

  const fetchtrPartydata = useCallback(() => {
    jwtAuthAxios
      .get("master/helper?salesman=1&Vendor=1&party=1")
      .then((res) => {
        setHelperData(res.data.data);
      })
      .catch(alert);
  });

  const fetchCurrencyData = useCallback(() => {
    jwtAuthAxios
      .get("master/helper?curr=1")
      .then((res) => {
        setCurrency(res.data.data);
      })
      .catch(alert);
  }, []);

  useEffect(() => {
    let isMounted = true;

    fetchtrPartydata();
    fetchCurrencyData();
    return () => {
      isMounted = false;
    };
  }, []);

  const handlePdf = async (values) => {
    let payload = {
      P_PARTY_CODE: values.P_PARTY_CODE,
      P_frdt: moment(values.P_frdt).format("DD/MM/YYYY"),
      P_todt: moment(values.P_todt).format("DD/MM/YYYY"),
      // type: values.type,
      P_curr: values.P_curr,
    };
    await jwtAuthAxios
      .post("/accreport/reportworker", {
        ...payload,
        desformat: "PDF",
        report: "adv_os.rdf",
        outfile: "advanceReport.pdf",
      })
      .then((res) => {
        if (res?.status == 200) {
          window.open(`https://admin.blossomdiam.com${res.data}`);
        } else {
          swal.fire({
            icon: "error",
            text: res.data.message,
          });
        }
      })
      .catch(() => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };

  return (
    <div style={{ padding: "20px" }}>
      <JumboCardQuick title={"Advance Outstanding"}>
        <Paper elevation={0}>
          <Formik
            initialValues={formval}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              handlePdf(values);
              setSubmitting(false);
            }}
          >
            {({ values, handleChange, setValues, setFieldValue }) => (
              <Form>
                <Grid container spacing={2}>
                  {/* <Grid item md={4} xs={12}>
                    <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                      <Autocomplete
                        id="TR-type"
                        size="small"
                        options={["ALL", "OUTSTANDING"]}
                        disableCloseOnSelect
                        value={values.type}
                        name="type"
                        onChange={(event, newValue) => {
                          setValues({
                            ...values,
                            type: newValue,
                          });
                        }}
                        defaultValue={["ALL", "OUTSTANDING"]?.filter((p) =>
                          values.type?.includes(p)
                        )}
                        getOptionLabel={(option) =>
                          Array.isArray(option) ? "" : option
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={
                                <CheckBoxOutlineBlankIcon fontSize="small" />
                              }
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Type"
                            placeholder="..."
                          />
                        )}
                      />
                      <ErrorMessage
                        name="transactionType"
                        component="div"
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "4px",
                        }}
                      />
                    </FormControl>
                  </Grid> */}
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                      <Select
                        size="small"
                        id="P_PARTY_CODE"
                        value={values.P_PARTY_CODE || ""}
                        onChange={handleChange}
                        name="P_PARTY_CODE"
                        displayEmpty
                        renderValue={
                          values.P_PARTY_CODE != ""
                            ? undefined
                            : () => <InputLabel>Party</InputLabel>
                        }
                      >
                        <MenuItem value="">Select Party</MenuItem>
                        {HelperData.PARTY?.map((party) => (
                          <MenuItem
                            key={party.FL_PARTY_CODE}
                            value={party.FL_PARTY_CODE}
                          >
                            {party.FL_PARTY_NAME}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                      <Select
                        size="small"
                        id="P_curr"
                        value={values.P_curr || []}
                        onChange={handleChange}
                        name="P_curr"
                        displayEmpty
                        renderValue={
                          values.P_curr != ""
                            ? undefined
                            : () => <InputLabel>Currency</InputLabel>
                        }
                      >
                        <MenuItem value="" disabled>
                          Select Currency
                        </MenuItem>
                        {currency?.CURR?.map((item) => (
                          <MenuItem
                            key={item.FL_CURRENCY_ID}
                            value={item.FL_CURRENCY_ID}
                          >
                            {item.FL_CURRENCY_NAME}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <ErrorMessage
                      name="P_curr"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      margin="normal"
                      type="date"
                      label="From Date"
                      name="P_frdt"
                      value={values.P_frdt}
                      InputLabelProps={{ shrink: true }}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="P_frdt"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      margin="normal"
                      type="date"
                      label="To Date"
                      InputLabelProps={{ shrink: true }}
                      name="P_todt"
                      value={values.P_todt}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="P_todt"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    />
                  </Grid>
                </Grid>

                <DialogActions>
                  <Div>
                    <PopupState variant="popover" popupId="demo-popup-menu">
                      {(popupState) => (
                        <React.Fragment>
                          <Button variant="contained" type="submit">
                            Pdf
                          </Button>
                        </React.Fragment>
                      )}
                    </PopupState>
                  </Div>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Paper>
      </JumboCardQuick>
    </div>
  );
};
AdvanceOutstandingReport.Modulename = "expensepayment";
export default AdvanceOutstandingReport;
